module.exports = __webpack_public_path__ + "img/gug_stats_panel.278fa83b.jpg";